import { Component, Input, HostListener, ElementRef } from '@angular/core';

@Component({
    selector: 'custom-tooltip',
    template: `
    <span class="tooltip-trigger" (mouseenter)="show()" (mouseleave)="hide()">
      <ng-content></ng-content>
      <div class="custom-tooltip-box" *ngIf="visible" [innerHTML]="content"></div>
    </span>
  `,
    styleUrls: ['./custom-tooltip.component.scss'],
    standalone: false
})
export class CustomTooltipComponent {
  @Input() content: string = '';
  visible = false;

  show() { this.visible = true; }
  hide() { this.visible = false; }
}
